import { withLayout } from '../Layout/Layout';
import { PopularDirections } from '../components/LandingPage/PopularDirections/PopularDirections';
import { httpGet } from '../utils/httpClient';
import ScrollableContent from '../components/ScrollableContent/ScrollableContent';
import styles from '../components/LandingPage/LandingPage.module.scss';
import React from 'react';

export const getServerSideProps = async ({
  query: { routesPage = 0, directionsPage = 0 },
}) => {
  const popularDirectionsRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=economy-class&directionsOnly=true&page=${directionsPage}&size=18`
  );
  const popularRoutesRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=economy-class&routesOnly=true&page=${routesPage}&size=18`
  );

  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation`
  );
  const recommendation = await recommendationRes.json();
  if (popularDirectionsRes.status >= 400) {
    return {
      notFound: true,
    };
  }
  const popularDirections = await popularDirectionsRes.json();
  const popularRoutes = await popularRoutesRes.json();
  const totalRoutesPages = popularRoutes.totalPages;
  const totalDirectionsPages = popularDirections.totalPages;

  return {
    props: {
      popularDirections,
      popularRoutes,
      recommendation,
      totalRoutesPages,
      totalDirectionsPages,
      routesPage,
      directionsPage,
    },
  };
};

function Flights({
  popularDirections,
  popularRoutes,
  routesPage,
  directionsPage,
  totalRoutesPages,
  totalDirectionsPages,
  recommendation,
  authCompleted,
}) {
  const seoHtml = (
    <div className={'container mt-4 lg:pl-4 px-4 lg:pr-0'}>
      <h2 className={'text-left'}>Find Cheap Flights, Tickets and Deals</h2>

      <p>
        Find and book cheap flight tickets with ease - in all cabin classes!
        First-Class.com is your ultimate destination for finding the best
        deals on affordable flights and low-cost airline tickets. Whether
        you&apos;re planning a business trip or a well-deserved vacation,
        we&apos;ve got you covered with our wide selection of flights at
        competitive prices.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Discover Affordable Flights for Your Next Adventure
        </h2>
      </p>
      <p>
        When it comes to finding reasonably priced flights, we understand that
        price is a crucial factor. That&apos;s why we specialise in offering a
        variety of options to suit every budget. Our user-friendly search tool
        allows you to quickly compare prices from different airlines and find
        the best flight deals. Whether you&apos;re looking for last-minute
        discounts or planning ahead, we&apos;ve got you covered.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Book Cheap Airline Tickets with Ease</h2>
      </p>
      <p>
        Booking cheap flights has never been easier. At First-Class.com, we
        strive to provide a seamless booking experience for our customers. With
        just a few clicks, you can search for the cheapest flights, choose your
        preferred airline, and secure your tickets. Our intuitive interface and
        secure payment options ensure a hassle-free booking process.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Discover Amazing Deals on Budget-Friendly Flights
        </h2>
      </p>
      <p>
        If you&apos;re on the lookout for the best flight deals, look no
        further. Our dedicated team of travel experts scours the web to find the
        lowest airfares and exclusive discounts. We work closely with major
        airlines and travel partners to bring you the most affordable flights
        available. At First-Class.com, we believe that everyone deserves to
        travel without breaking the bank.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Your One-Stop Destination for Economy Flights
        </h2>
      </p>
      <p>
        With our extensive network of airline partners, we can offer you a wide
        range of options for your travel needs. From domestic flights to
        international destinations, we&apos;ve got it all covered. No matter
        where you&apos;re going, you can find the best prices on budget-friendly
        airline tickets at First-Class.com. Don&apos;t waste time searching
        multiple websites when you can find everything you need in one place.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Fly Stress-Free with Affordable Flight Tickets
        </h2>
      </p>
      <p>
        We understand that traveling can be stressful, especially when it comes
        to finding reasonably priced airfare. That&apos;s why we make it our
        mission to take the stress out of booking flights. With our
        comprehensive search engine, you can find the most economical flights
        without compromising on quality or comfort. Rest assured that
        you&apos;ll enjoy a smooth and pleasant journey while saving money.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Book Your Cheap Flight Today</h2>
      </p>
      <p>
        Ready to embark on your next adventure? Don&apos;t let expensive flights
        hold you back. Visit First-Class.com now to find the most affordable
        flights, book your airline tickets, grab the cheapest flight ticket and
        save big on your travel expenses.
        <p>&nbsp;</p>
        At First-Class.com, we understand the importance of finding affordable
        flights that suit your travel needs and budget. Whether you&apos;re
        planning a business trip, a family vacation, or a spontaneous getaway,
        our platform is designed to help you find the best deals on flights,
        ensuring a seamless and cost-effective travel experience.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Find Affordable Flights with Ease</h2>
      </p>
      <p>
        When it comes to searching for affordable flights, we&apos;ve got you
        covered. Our user-friendly website allows you to effortlessly browse and
        compare a wide range of flight options, ensuring you find the most
        reasonably priced fares available. With just a few clicks, you can
        easily navigate through our extensive selection of flights, making the
        process quick, convenient, and stress-free.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Book a Flight That Fits Your Budget</h2>
      </p>
      <p>
        With our extensive network of airlines and travel partners, we offer a
        wide range of options to suit every budget. Whether you&apos;re looking
        for the most budget-friendly flights available or seeking the best value
        for your money, our platform allows you to filter and sort your search
        results based on price, helping you find the perfect flight at the right
        price.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Discover Amazing Deals on Affordable Flights
        </h2>
      </p>
      <p>
        At First-Class.com, we pride ourselves on delivering fantastic deals
        on affordable flights. Our team of travel experts constantly scours the
        market for the best flight offers, ensuring you have access to exclusive
        deals and discounts. By leveraging our partnerships with major airlines
        and travel providers, we can bring you the lowest fares and the best
        value for your money.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Save Time & Money with First-Class.com
        </h2>
      </p>
      <p>
        We understand that time and money are valuable resources when it comes
        to travel. That&apos;s why we&apos;ve designed our platform to
        streamline the flight booking process and maximise savings. With our
        intuitive search and booking system, you can easily compare prices,
        select the most affordable options, and secure your flight within
        minutes. By eliminating the hassle of searching multiple websites and
        comparing prices manually, we help you save both time and money.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Fly with Confidence & Convenience</h2>
      </p>
      <p>
        Booking your affordable flight through First-Class.com doesn&apos;t
        mean sacrificing quality or convenience. We partner with reputable
        airlines that prioritise customer satisfaction, ensuring you enjoy a
        comfortable and enjoyable flight experience. From spacious seating and
        in-flight entertainment to exceptional customer service, we strive to
        make your journey as pleasant as possible.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Find Cheap Affordable Flights Anytime, Anywhere
        </h2>
      </p>
      <p>
        Our online platform is accessible 24/7, allowing you to search for
        affordable flights whenever and wherever you need them. Whether
        you&apos;re planning well in advance or looking for last-minute deals,
        First-Class.com is your go-to source for cost-effective air travel.
        With our advanced search filters and comprehensive flight information,
        you can confidently find the best flights at the best prices, no matter
        your destination or travel dates.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>Last Minute Deals on Cheap Flights</h2>
      </p>
      <p>
        At First-Class.com, we understand that sometimes you need to be
        spontaneous and grab those last-minute travel opportunities. That&apos;s
        why we&apos;re thrilled to offer an array of incredible last minute
        deals on affordable flights. Whether you suddenly find yourself with
        some free time or simply want to take advantage of a great offer, our
        platform is here to help you find the best last-minute flight deals.
        With our extensive network of airlines and travel partners, we can bring
        you exclusive discounts and low fares on flights to various
        destinations. Don&apos;t miss out on the chance to jet off on an
        exciting adventure at a fraction of the price. Visit First-Class.com
        now to discover the best last-minute deals and book your affordable
        flight with ease. Your spontaneous travel plans are just a click away!
        Book Your Affordable Flight Today
        <p>&nbsp;</p>
        Don&apos;t let expensive flights hold you back from exploring the world
        or reaching your desired destination. At First-Class.com, we&apos;re
        dedicated to helping you find the most affordable flights available, so
        you can make your travel dreams a reality. Start your journey today by
        visiting our website and discovering the incredible deals and savings
        that await you. Book your affordable flight with First-Class.com and
        embark on your next adventure with confidence.
      </p>
      <p>&nbsp;</p>
      {+directionsPage === 0 && +routesPage === 0 && (
        <div className={'mt-4'}>
          <ScrollableContent
            heading={
              <h3>How can I find affordable flights on First-Class.com?</h3>
            }
            content={
              <p>
                You can find affordable flights on First-Class.com by using
                our user-friendly search tool. Simply enter your travel details,
                and our platform will provide you with a wide selection of
                flights at competitive prices. You can compare prices from
                different airlines and choose the best flight deal that suits
                your budget.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>Can I book cheap airline tickets on First-Class.com?</h3>
            }
            content={
              <p>
                Yes, you can book cheap airline tickets on First-Class.com. We
                strive to provide a seamless booking experience, and our
                platform allows you to search for the most affordable flights,
                select your preferred airline, and secure your tickets with
                ease. We offer a range of options to suit every budget.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>
                Does First-Class.com offer exclusive discounts and deals on
                flights?
              </h3>
            }
            content={
              <p>
                Yes, First-Class.com offers exclusive discounts and deals on
                flights. Our dedicated team of travel experts constantly
                searches the web to find the lowest airfares and exclusive
                discounts for our customers. We work closely with major airlines
                and travel partners to bring you the most affordable flights
                available.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>Is First-Class.com only for Business Class flights?</h3>
            }
            content={
              <p>
                No, First-Class.com offers a wide range of flight options,
                including economy class flights. We have an extensive network of
                airline partners, allowing us to provide options for all travel
                needs, from domestic flights to international destinations.
                Whether you&apos;re looking for economy class or other travel
                classes, you can find the best prices on budget-friendly plane
                tickets on our platform.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>Are last-minute deals available on First-Class.com?</h3>
            }
            content={
              <p>
                Yes, First-Class.com offers last-minute deals on cheap
                affordable flights. If you&apos;re looking for spontaneous
                travel opportunities or want to take advantage of great offers,
                our platform provides an array of incredible last-minute deals.
                With our extensive network of airlines and travel partners, we
                can bring you exclusive discounts and low fares on flights to
                various destinations.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={<h3>Does First-Class.com offer flights worldwide?</h3>}
            content={
              <p>
                Yes, First-Class.com offers flights worldwide. We have a wide
                range of airline partners and destinations, covering both
                domestic and international flights. No matter where you want to
                go, you can find affordable flights to various destinations
                through our platform
              </p>
            }
            style={styles.scrollableContentSub}
          />
        </div>
      )}
    </div>
  );
  return (
    <>
      <PopularDirections
        popularDirections={popularDirections}
        recommendation={recommendation}
        popularRoutes={popularRoutes}
        routesPage={routesPage}
        directionsPage={directionsPage}
        totalRoutesPages={totalRoutesPages}
        totalDirectionsPages={totalDirectionsPages}
        topImage={'/images/economy-class.jpg'}
        authCompleted={authCompleted}
        seoHTML={seoHtml}
      />
    </>
  );
}

export default withLayout(Flights, false);
